module.exports = __webpack_public_path__ + "img/1VP1lhSAhLkpkauhAkNXNblcaCRJyJNmk.e96ae6c3.png";